import React, { Component, Fragment } from 'react';

const imgSrcDir = '/Static/prod/images/careers-page';

const wilhelmsenLogo = `${imgSrcDir}/wilhelmsen-logo.png`;
const thyssenkruppLogo = `${imgSrcDir}/thyssenkrupp-logo.png`;

export default class CtaCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { image, alt, heading, paragraph, url, isLast, showLogos } =
      this.props;
    const wrapperClassName = `careers-page__cta-card${
      isLast ? ' careers-page__cta-card--last' : ''
    }`;

    return (
      <div className={wrapperClassName}>
        <img src={image} alt={alt} />
        {isLast ? (
          <p>...could be your idea.</p>
        ) : (
          <Fragment>
            <h3>{heading}</h3>
            <p>{paragraph}</p>
          </Fragment>
        )}
        {showLogos && (
          <div
            className="careers-page__cta-card__sublogos"
            style={{ marginTop: 'auto' }}
          >
            <img src={wilhelmsenLogo} alt="Wilhelmsen logo" />
            <img src={thyssenkruppLogo} alt="Thyssenkrupp logo" />
          </div>
        )}
        <button
          className="cta-btn"
          type="button"
          onClick={() => window.open(url, '_blank')}
          style={{ marginTop: (isLast || showLogos) && 'initial' }}
        >
          {isLast ? 'Apply' : 'Learn more'}
        </button>
      </div>
    );
  }
}
